<template>
  <v-container fluid>
    <data-table
      :filters="filters"
      :limit="10"
      url="users"
      fields="email,first_name,last_name,last_activity,role.display_name,status,created_at"
      content="usersListChat"
      searchFields="first_name,last_name,email"
      class="mb-5">
      <template slot="title">
        <v-layout row wrap>
          <v-flex md9>
            <p class="headline mt-3">
              Configuración del chat center
            </p>
          </v-flex>
          <v-flex md3 class="text-xs-right">
            <v-btn class="k-orange-linear white--text mt-2 mr-0" large @click="showConfig">
              CONFIGURACIÓN
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template slot="navigation-bar">
        <v-flex lg4>
          <v-text-field
            v-model="filters.search"
            label="Buscar..."
            color="black"
            solo>
          </v-text-field>
        </v-flex>
        <v-flex lg2 pl-2>
          <v-select
            v-model="filters.status"
            :items="statuses"
            color="grey"
            solo>
          </v-select>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-menu
            ref="from"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters['min-created_at']"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              :value="formatDate(filters['min-created_at'], 'YYYY-MM-DD', 'DD/MM/YYYY')"
              class="k-orange-linear-text"
              prepend-icon="event"
              label="Desde"
              readonly
              solo>
            </v-text-field>
            <v-date-picker
              v-model="filters['min-created_at']"
              @input="$refs.from.save(filters['min-created_at'])"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-menu
            ref="to"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters['max-created_at']"
            transition="scale-transition"
            min-width="290px"
            full-width
            offset-y
            lazy>
            <v-text-field
              slot="activator"
              :value="formatDate(filters['max-created_at'], 'YYYY-MM-DD', 'DD/MM/YYYY')"
              class="k-orange-linear-text"
              prepend-icon="event"
              label="Hasta"
              readonly
              solo>
            </v-text-field>
            <v-date-picker
              v-model="filters['max-created_at']"
              @input="$refs.to.save(filters['max-created_at'])"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
      </template>
    </data-table>
    <save-dialog
      title="Cambiar configuración"
      :dialog="dialog"
      :clearformed="true"
      :form="form"
      route="chats_centers/config"
      :edit="true"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12 md6 pr-3>
            <v-text-field
              v-model="form.name"
              min="0"
              :disabled="!checkCategory"
              :label="labelCategory"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.close"
              v-validate="'max:191'"
              data-vv-name="close"
              type="number"
              min="0"
              data-vv-as="días para cerrar un chat no resuelto"
              :error-messages="errors.collect('close')"
              label="Días para cerrar un chat no resuelto"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="form.agent_limit"
              v-validate="'max:191'"
              data-vv-name="agent_limit"
              type="number"
              min="0"
              data-vv-as="número maximo de chats que puede tener un agente"
              :error-messages="errors.collect('agent_limit')"
              label="Número maximo de chats que puede tener un agente"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="false">
          <v-flex xs12>
            <v-text-field
              v-model="form.away_time"
              v-validate="'required|max:191'"
              data-vv-name="away_time"
              type="number"
              min="0"
              data-vv-as="minutos para gestionar la ausencia del cliente"
              :error-messages="errors.collect('away_time')"
              label="Minutos para gestionar la ausencia del cliente"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <save-dialog
      :title="channelsTitle"
      :dialog="channelDialog"
      :clearformed="true"
      :form="channelsUser"
      :route="channelRoute"
      :edit="true"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <v-layout row wrap pl-5 pr-5>
          <v-flex class="justify-center text-xs-center" xs12 md4 v-for="(channel,i) in channels" :key="i">
           <v-checkbox 
            v-model="channelsUser[channel.value]" 
            :label="channel.description"
            class="k-orange-linear-text"/>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
  </v-container>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import DataTable from '@/components/global/DataTable';
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import UsersListChat from '@/components/user/UsersListChat';
import formatDateMixin from '@/mixins/formatDate';
import EventBus from '@/event-bus';

Vue.component('UsersListChat', UsersListChat);

export default {
  components: {
    DataTable,
    SaveDialog,
  },
  mixins: [
    saveDialogMixin,
    formatDateMixin,
  ],
  mounted() {
    EventBus.$on('changeChannels', (user) => {
      this.user.id = user.id;
      this.user.name = `${user.first_name} ${user.last_name}`;
      for (let i = 0; i < this.channels.length; i += 1) {
        const value = this.channels[i].value;
        const { channels } = { ...user.chat_center_filters };
        // eslint-disable-next-line
        this.channelsUser[value] = (channels || []).includes(value);
      }
      this.channelDialog = true;
    });
    EventBus.$on('closeModal', () => {
      this.channelDialog = false;
    });
  },
  destroyed() {
    EventBus.$off('changeChannels');
    EventBus.$off('changeChannels');
  },
  computed: {
    channelRoute() {
      return `chats_centers/${this.user.id}/config`;
    },
    channelsTitle() {
      return `Canales asignados al usuario ${this.user.name}`;
    },
    labelCategory() {
      return this.form.close_category_id ? 'Categoría' : 'Crear categoría';
    },
    checkCategory() {
      return _.isNil(this.form.close_category_id);
    },
  },
  data() {
    return {
      channelDialog: false,
      user: {
        id: 0,
        name: '',
      },
      channelsUser: {
        sms: false,
        whatsapp: false,
        email: false,
      },
      channels: [
        {
          description: 'SMS',
          value: 'sms',
        },
        {
          description: 'Whatsapp',
          value: 'whatsapp',
        },
        {
          description: 'Email',
          value: 'email',
        },
      ],
      filters: {
        search: '',
        status: '',
        'min-created_at': '',
        'max-created_at': '',
        sort: '-created_at',
      },
      statuses: [
        {
          value: '',
          text: 'Estados',
        },
        {
          value: 'activo',
          text: 'Activo',
        },
        {
          value: 'inactivo',
          text: 'Inactivo',
        },
        {
          value: 'pendiente',
          text: 'Pendiente',
        },
      ],
      form: {
        close: 0,
        close_category_id: null,
        agent_limit: 0,
        away_time: 0,
        name: '',
      },
      roles: [
        {
          value: 1,
          text: 'Administrador',
        },
        {
          value: 2,
          text: 'Analista',
        },
        {
          value: 3,
          text: 'Agente',
        },
        {
          value: 4,
          text: 'Call center',
        },
      ],
      fields: 'email,first_name,last_name,role_id,agency_id',
    };
  },
  methods: {
    showConfig() {
      this.axios.get('chats_centers/config').then((response) => {
        if (response.data) {
          const temp = _.pick(response.data, ['close', 'close_category_id', 'agent_limit', 'away_time', 'chat_category.name']);
          temp.name = (temp.chat_category || {}).name;
          delete temp.chat_category;
          this.form = temp;
        }
        this.dialog = true;
      }).catch();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center/Config.vue